//here value of 1 is for true, 0 is for false,2 is for readonly,3 is for otp and 4 is for Own summary

const roleAccessInfo = {
    easymembr: {
        owner: {
            dashboard: {
                access: true,
                accessinfo: { today: 1, yesterday: 1, week: 1, month: 1, customrange: 1 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    businessdetails: 1,
                    paymentmethods: 1,
                    taxsettings: 1,
                    digitalwaiver: 1,
                    businesshours: 1,
                    geolocation: 1,
                },
            },
            membersmanagement: {
                access: true,
                accessinfo: { search: 1, export: 1, whatsapp: 1, import: 1, addmember: 1 },
            },
            checkin: { access: true, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 1,
                    checkinreportsexport: 1,
                    trainersummary: 1,
                    checkincount: 1,
                    checkincountexport: 1,
                    paymentsummary: 1,
                    plansummary: 1,
                    session: 1,
                    sessionsummary: 1,
                    smshistory: 1,
                    whatsappcampaignhistory: 1,
                    whatsappnotificationhistory: 1,
                    revenuereport: 1,
                    activemembershistory: 1,
                    renewprediction: 1,
                    schedulesummary: 1
                },
            },
            staff: { access: true, accessinfo: { editstaff: 1 } },
            membership: { access: true, accessinfo: { editmembership: 1, import: 1 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 1,
                    totaltransactionscount: 1,
                    delete: 1,
                    export: 1,
                    import: 1,
                    pagination: 1,
                    refund: 1,
                    paymentlinks: 1,
                },
            },
            activities: { access: true, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 1 } },
            templatesandreminders: { access: true, accessinfo: {} },
            manageaccount: { access: true, accessinfo: {} },
            memberdetails: {
                access: true,
                accessinfo: {
                    checkin: 1,
                    editmember: 1,
                    suspend: 1,
                    dnd: 1,
                    editmembership: 1,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 1 } },
        },

        manager: {
            dashboard: {
                access: true,
                accessinfo: { today: 1, yesterday: 0, week: 0, month: 0, customrange: 0 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    businessdetails: 0,
                    paymentmethods: 0,
                    taxsettings: 0,
                    digitalwaiver: 2,
                    businesshours: 2,
                    geolocation: 0,
                },
            },
            membersmanagement: {
                access: true,
                accessinfo: { search: 1, export: 0, whatsapp: 0, import: 0, addmember: 1 },
            },
            checkin: { access: true, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 1,
                    checkinreportsexport: 0,
                    trainersummary: 1,
                    checkincount: 0,
                    checkincountexport: 0,
                    paymentsummary: 0,
                    plansummary: 0,
                    session: 0,
                    sessionsummary: 0,
                    smshistory: 0,
                    whatsappcampaignhistory: 0,
                    whatsappnotificationhistory: 0,
                    revenuereport: 0,
                    activemembershistory: 0,
                    renewprediction: 0,
                    schedulesummary: 0
                },
            },
            staff: { access: true, accessinfo: { editstaff: 1 } },
            membership: { access: true, accessinfo: { editmembership: 1, import: 1 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 0,
                    totaltransactionscount: 0,
                    delete: 1,
                    export: 0,
                    import: 0,
                    pagination: 0,
                    refund: 1,
                    paymentlinks: 0,
                },
            },
            activities: { access: false, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 2 } },
            templatesandreminders: { access: true, accessinfo: { edittemplate: 2 } },
            manageaccount: { access: false, accessinfo: {} },
            memberdetails: {
                access: true,
                accessinfo: {
                    checkin: 1,
                    editmember: 1,
                    suspend: 1,
                    dnd: 1,
                    editmembership: 1,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 1 } },
        },

        trainer: {
            dashboard: {
                access: true,
                accessinfo: { today: 1, yesterday: 0, week: 0, month: 0, customrange: 0 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    businessdetails: 0,
                    paymentmethods: 0,
                    taxsettings: 0,
                    digitalwaiver: 2,
                    businesshours: 2,
                    geolocation: 0,
                },
            },
            membersmanagement: {
                access: true,
                accessinfo: { search: 1, export: 0, whatsapp: 0, import: 0, addmember: 1 },
            },
            checkin: { access: true, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 1,
                    checkinreportsexport: 0,
                    trainersummary: 4,
                    checkincount: 0,
                    checkincountexport: 0,
                    paymentsummary: 0,
                    plansummary: 0,
                    session: 0,
                    sessionsummary: 0,
                    smshistory: 0,
                    whatsappcampaignhistory: 0,
                    whatsappnotificationhistory: 0,
                    revenuereport: 0,
                    activemembershistory: 0,
                    renewprediction: 0,
                    schedulesummary: 0
                },
            },
            staff: { access: true, accessinfo: { editstaff: 2 } },
            membership: { access: true, accessinfo: { editmembership: 2, import: 0 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 0,
                    totaltransactionscount: 0,
                    delete: 3,
                    export: 0,
                    import: 0,
                    pagination: 0,
                    refund: 1,
                    paymentlinks: 0,
                },
            },
            activities: { access: false, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 2 } },
            templatesandreminders: { access: true, accessinfo: { edittemplate: 2 } },
            manageaccount: { access: false, accessinfo: {} },
            memberdetails: {
                access: true,
                accessinfo: {
                    checkin: 1,
                    editmember: 1,
                    suspend: 1,
                    dnd: 0,
                    editmembership: 0,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 0 } },
        },

        frontdesk: {
            dashboard: {
                access: true,
                accessinfo: { today: 1, yesterday: 0, week: 0, month: 0, customrange: 0 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    businessdetails: 0,
                    paymentmethods: 0,
                    taxsettings: 0,
                    digitalwaiver: 2,
                    businesshours: 2,
                    geolocation: 0,
                },
            },
            membersmanagement: {
                access: true,
                accessinfo: { search: 1, export: 0, whatsapp: 0, import: 0, addmember: 1 },
            },
            checkin: { access: true, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 1,
                    checkinreportsexport: 0,
                    trainersummary: 1,
                    checkincount: 0,
                    checkincountexport: 0,
                    paymentsummary: 0,
                    plansummary: 0,
                    session: 0,
                    sessionsummary: 0,
                    smshistory: 0,
                    whatsappcampaignhistory: 0,
                    whatsappnotificationhistory: 0,
                    revenuereport: 0,
                    activemembershistory: 0,
                    renewprediction: 0,
                    schedulesummary: 0
                },
            },
            staff: { access: true, accessinfo: { editstaff: 2 } },
            membership: { access: true, accessinfo: { editmembership: 2, import: 0 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 0,
                    totaltransactionscount: 0,
                    delete: 3,
                    export: 0,
                    import: 0,
                    pagination: 0,
                    refund: 1,
                    paymentlinks: 0,
                },
            },
            activities: { access: false, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 2 } },
            templatesandreminders: { access: true, accessinfo: { edittemplate: 2 } },
            manageaccount: { access: false, accessinfo: {} },
            memberdetails: {
                access: true,
                accessinfo: {
                    checkin: 1,
                    editmember: 1,
                    suspend: 1,
                    dnd: 0,
                    editmembership: 0,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 0 } },
        },

        accountant: {
            dashboard: {
                access: true,
                accessinfo: { today: 1, yesterday: 0, week: 0, month: 0, customrange: 0 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    businessdetails: 2,
                    paymentmethods: 0,
                    taxsettings: 1,
                    digitalwaiver: 2,
                    businesshours: 2,
                    geolocation: 0,
                },
            },
            membersmanagement: {
                access: false,
                accessinfo: { search: 0, export: 0, whatsapp: 0, import: 0, addmember: 1 },
            },
            checkin: { access: true, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 0,
                    checkinreportsexport: 0,
                    trainersummary: 0,
                    checkincount: 0,
                    checkincountexport: 0,
                    paymentsummary: 1,
                    plansummary: 0,
                    session: 0,
                    sessionsummary: 0,
                    smshistory: 0,
                    whatsappcampaignhistory: 0,
                    whatsappnotificationhistory: 0,
                    revenuereport: 1,
                    activemembershistory: 0,
                    renewprediction: 0,
                    schedulesummary: 0
                },
            },
            staff: { access: true, accessinfo: { editstaff: 2 } },
            membership: { access: true, accessinfo: { editmembership: 2, import: 0 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 1,
                    totaltransactionscount: 1,
                    delete: 3,
                    export: 1,
                    import: 1,
                    pagination: 1,
                    refund: 1,
                    paymentlinks: 1,
                },
            },
            activities: { access: false, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 2 } },
            templatesandreminders: { access: true, accessinfo: { edittemplate: 2 } },
            manageaccount: { access: false, accessinfo: {} },
            memberdetails: {
                access: false,
                accessinfo: {
                    checkin: 0,
                    editmember: 0,
                    suspend: 0,
                    dnd: 0,
                    editmembership: 0,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 0 } },
        },

        campaignmanager: {
            dashboard: {
                access: false,
                accessinfo: { today: 0, yesterday: 0, week: 0, month: 0, customrange: 0 },
            },
            pointofsale: { access: true, accessinfo: {} },
            businessinfo: {
                access: false,
                accessinfo: {
                    businessdetails: 0,
                    paymentmethods: 0,
                    taxsettings: 0,
                    digitalwaiver: 0,
                    businesshours: 0,
                    geolocation: 0,
                },
            },
            membersmanagement: {
                access: true,
                accessinfo: { search: 1, export: 1, whatsapp: 1, import: 1, addmember: 1 },
            },
            checkin: { access: false, accessinfo: {} },
            reports: {
                access: true,
                accessinfo: {
                    checkinreports: 1,
                    checkinreportsexport: 1,
                    trainersummary: 4,
                    checkincount: 0,
                    checkincountexport: 0,
                    paymentsummary: 0,
                    plansummary: 0,
                    session: 0,
                    sessionsummary: 1,
                    smshistory: 1,
                    whatsappcampaignhistory: 1,
                    whatsappnotificationhistory: 1,
                    revenuereport: 1,
                    activemembershistory: 0,
                    renewprediction: 1,
                    schedulesummary: 0
                },
            },
            staff: { access: true, accessinfo: { editstaff: 2 } },
            membership: { access: true, accessinfo: { editmembership: 2, import: 0 } },
            transactions: {
                access: true,
                accessinfo: {
                    totalamount: 0,
                    totaltransactionscount: 0,
                    delete: 0,
                    export: 0,
                    import: 0,
                    pagination: 1,
                    refund: 0,
                    paymentlinks: 0,
                },
            },
            activities: { access: false, accessinfo: {} },
            yourwebsite: { access: true, accessinfo: { editwebsite: 1 } },
            templatesandreminders: { access: true, accessinfo: { edittemplate: 1 } },
            manageaccount: { access: false, accessinfo: {} },
            memberdetails: {
                access: true,
                accessinfo: {
                    checkin: 1,
                    editmember: 1,
                    suspend: 0,
                    dnd: 1,
                    editmembership: 0,
                },
            },
            leftpane: { access: true, accessinfo: { changeplan: 0 } },
        },
    },
    easybook: {
        owner: {
            classdashboard: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 1,
                    termsandconditions: 1,
                    privacypolicy: 1,
                    announcements: 1,
                    classbusinesssettings: 1,
                    businessdetails: 1,
                    businesshours: 1,
                    digitalwaiver: 1,
                    geolocation: 1,
                    taxsettings: 1,
                },
            },
            classes: { access: true, accessinfo: { editclass: 1 } },
            schedules: { access: true, accessinfo: { editevent: 1 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 1,
                    export: 1,
                    pagination: 1,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 1 } },
            classactivities: { access: true, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 1 } },
        },

        manager: {
            classdashboard: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 1,
                    termsandconditions: 1,
                    privacypolicy: 1,
                    announcements: 1,
                    classbusinesssettings: 1,
                    businessdetails: 1,
                    businesshours: 1,
                    digitalwaiver: 1,
                    geolocation: 1,
                    taxsettings: 1,
                },
            },
            classes: { access: true, accessinfo: { editclass: 1 } },
            schedules: { access: true, accessinfo: { editevent: 1 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 1,
                    export: 0,
                    pagination: 0,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 1 } },
            classactivities: { access: false, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 1 } }
        },

        trainer: {
            classdashboard: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 2,
                    termsandconditions: 2,
                    privacypolicy: 2,
                    announcements: 2,
                    classbusinesssettings: 2,
                    businessdetails: 2,
                    businesshours: 2,
                    digitalwaiver: 2,
                    geolocation: 2,
                    taxsettings: 2,
                },
            },
            classes: { access: true, accessinfo: { editclass: 2 } },
            schedules: { access: true, accessinfo: { editevent: 2 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 3,
                    export: 0,
                    pagination: 0,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 2 } },
            classactivities: { access: false, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 2 } },
        },

        frontdesk: {
            classdashboard: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 2,
                    termsandconditions: 2,
                    privacypolicy: 2,
                    announcements: 2,
                    classbusinesssettings: 2,
                    businessdetails: 2,
                    businesshours: 2,
                    digitalwaiver: 2,
                    geolocation: 2,
                    taxsettings: 2,
                },
            },
            classes: { access: true, accessinfo: { editclass: 2 } },
            schedules: { access: true, accessinfo: { editevent: 2 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 3,
                    export: 0,
                    pagination: 0,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 2 } },
            classactivities: { access: false, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 2 } },
        },

        accountant: {
            classdashboard: { access: false, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 2,
                    termsandconditions: 1,
                    privacypolicy: 1,
                    announcements: 2,
                    classbusinesssettings: 2,
                    businessdetails: 2,
                    businesshours: 2,
                    digitalwaiver: 2,
                    geolocation: 2,
                    taxsettings: 1,
                },
            },
            classes: { access: true, accessinfo: { editclass: 2 } },
            schedules: { access: true, accessinfo: { editevent: 2 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 3,
                    export: 1,
                    pagination: 1,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 2 } },
            classactivities: { access: false, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 2 } },
        },

        campaignmanager: {
            classdashboard: { access: true, accessinfo: {} },
            businessinfo: {
                access: true,
                accessinfo: {
                    userclassbookingurl: 1,
                    termsandconditions: 2,
                    privacypolicy: 2,
                    announcements: 1,
                    classbusinesssettings: 2,
                    businessdetails: 0,
                    businesshours: 0,
                    digitalwaiver: 0,
                    geolocation: 0,
                    taxsettings: 0,
                },
            },
            classes: { access: true, accessinfo: { editclass: 1 } },
            schedules: { access: true, accessinfo: { editevent: 1 } },
            classtransaction: {
                access: true,
                accessinfo: {
                    delete: 0,
                    export: 0,
                    pagination: 1,
                },
            },
            trainers: { access: true, accessinfo: { edittrainer: 2 } },
            classactivities: { access: false, accessinfo: {} },
            cancelationpolicy: { access: true, accessinfo: { editpolicy: 2 } },
        },
    },
    _id: -1
}

export default roleAccessInfo;


const roleMap = {
    1: "owner",
    2: "manager",
    3: "trainer",
    4: "frontdesk",
    5: "accountant",
    6: "campaignmanager"
};


export const fetchDefaultRoleAccess = async (module, rolevalues) => {
    try {
        let roleArray = [];
        if (Array.isArray(rolevalues)) {
            roleArray = rolevalues;
        } else if (typeof rolevalues === 'string') {
            roleArray = rolevalues.split(',').map(val => val.trim());
        } else {
            return { msg: "Invalid role value format" };
        }

        const validRoleValues = roleArray.map(val => parseInt(val)).filter(val => !isNaN(val));
        const validRoles = validRoleValues
            .map(roleValue => roleMap[roleValue])
            .filter(role => role && roleAccessInfo[module]?.[role]);

        if (validRoles.length === 0) {
            return { msg: `No valid roles found for module ${module}` };
        }

        if (!roleAccessInfo[module]) {
            return { msg: `Module ${module} not found` };
        }

        // Helper function to merge access permissions
        const mergeAccess = (access1, access2) => {
            // Handle boolean values
            if (typeof access1 === 'boolean' && typeof access2 === 'boolean') {
                return access1 || access2;
            }

            // Handle number values with priority logic
            if (typeof access1 === 'number' && typeof access2 === 'number') {
                const priority = { 1: 5, 4: 4, 3: 3, 2: 2, 0: 1 };
                return priority[access1] > priority[access2] ? access1 : access2;
            }

            // Handle objects recursively
            if (typeof access1 === 'object' && access1 !== null &&
                typeof access2 === 'object' && access2 !== null) {
                const merged = { ...access1 };
                for (const key in access2) {
                    if (access2.hasOwnProperty(key)) {
                        merged[key] = merged.hasOwnProperty(key)
                            ? mergeAccess(merged[key], access2[key])
                            : access2[key];
                    }
                }
                return merged;
            }


            return access1 || access2;
        };


        const safeClone = (obj) => {
            if (obj === null || typeof obj !== 'object') return obj;
            if (obj instanceof Date) return new Date(obj);
            return JSON.parse(JSON.stringify(obj));
        };

        const roleAccesses = validRoles.map(role =>
            safeClone(roleAccessInfo[module][role])
        );

        const combinedAccess = roleAccesses.reduce((merged, currentAccess) => {
            for (const section in currentAccess) {
                if (currentAccess.hasOwnProperty(section)) {
                    if (!merged[section]) {
                        merged[section] = safeClone(currentAccess[section]);
                        continue;
                    }


                    if (currentAccess[section].access !== undefined) {
                        merged[section].access = mergeAccess(
                            merged[section].access,
                            currentAccess[section].access
                        );
                    }


                    if (currentAccess[section].accessinfo) {
                        merged[section].accessinfo = merged[section].accessinfo || {};
                        for (const key in currentAccess[section].accessinfo) {
                            if (currentAccess[section].accessinfo.hasOwnProperty(key)) {
                                merged[section].accessinfo[key] = mergeAccess(
                                    merged[section].accessinfo[key],
                                    currentAccess[section].accessinfo[key]
                                );
                            }
                        }
                    }
                }
            }
            return merged;
        }, {});

        return {
            module,
            roles: validRoles,
            roleValues: validRoleValues,
            access: combinedAccess
        };

    } catch (error) {
        console.error("Error in fetchDefaultRoleAccess:", error);
        return { msg: "Internal server error" };
    }
};


